const LAST_ACTIVE_KEY = 'LABEL.LAST_ACTIVE';

export const getLastActiveLabelId = () => localStorage.getItem(LAST_ACTIVE_KEY);

export const setLastActiveLabelId = (id: string) =>
  localStorage.setItem(LAST_ACTIVE_KEY, id);

export const clearLastActiveLabelId = () =>
  localStorage.removeItem(LAST_ACTIVE_KEY);
